import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative h-150 w-full',
    tabs: 'w-full',
    tab: 'flex-1',
    panelContent:
      'relative h-(--pickup-tab-content-height,min(600px,80vh)) w-full'
  }
});
